var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.8333L20.1667 0L40.3333 34.8333H0ZM20.1667 29.3333C20.6861 29.3333 21.1218 29.1573 21.4738 28.8053C21.8258 28.4533 22.0012 28.0182 22 27.5C21.9988 26.9818 21.8228 26.5467 21.472 26.1947C21.1212 25.8427 20.6861 25.6667 20.1667 25.6667C19.6472 25.6667 19.2121 25.8427 18.8613 26.1947C18.5106 26.5467 18.3346 26.9818 18.3333 27.5C18.3321 28.0182 18.5081 28.454 18.8613 28.8072C19.2146 29.1604 19.6497 29.3358 20.1667 29.3333ZM18.3333 23.8333H22V14.6667H18.3333V23.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a04dc592801e14e4e2fbaf50467c3e87.svg";
export { ForwardRef as ReactComponent };